import metricsBills from "./bills";
import metricsRequests from "./requests";
import metricsToastr from "./toastr";
import metricsProviderState from "./provider-state";
import metricsYodlee from "./yodlee";
import { updateTrackingParams } from "../../actions";
/**
 * Middleware that automatically handles tracking/logging of identity requests and events related
 * to the `<Auth>` component if using it (i.e. auth shown/success, steps shown/hidden, messages
 * shown to the user). **at this time this is not compatible with mobile**
 * @name  createMetricsMiddleware
 * @param  {object} [options.trk]              enumerated set of tracking params beginning with
 * `trk_` the middleware will set most of these for you automatically but if you wish to override
 * defaults or set any of the optional params (`trk_element`, `trk_location`. `trk_copy`) you can
 * set them here.
 * @param  {object} [options.amplitudeOnlyTrk] any additional tracking params you want logged with
 * all tracking events to amptlitude. These are optional, non-restricted, and will show up in
 * Amplitude only (not DWH).
 * @return {function}                          Redux middleware instance
 * @see How To: Track Registration Flows as a Vertical: {@link
 * https://nerdwallet.atlassian.net/wiki/display/PRODUCT/How+To%3A+Track+Registration+Flows+as+a+Vertical}
 * @param  {string} [options.appName ]         appName for namespacing tracking events `appName`
 * is used for `NWTracking` to namespace events by app. By default all events are logged as type
 * `FORM_INPUT_CHANGED` with the event name in `formName` field (e.g. `request:register:success`).
 * Defining an appName is totally optional and will result in double logging the event as
 * `[eventName]:[appName]` (e.g. `request:register:success:MY_NERDWALLET` which scanning amplitude
 * logs easier. If you choose to include it it must be one of: [application name enum].
 *
 * @example
 * import { createMetricsMiddleware } from '@nerdwallet/js-auth-tools'
 * const metricsMiddleware = createMetricsMiddleware({
 *   appName: 'YOUR_APP_NAME',
 *   trk: {
 *     // addtional optional trk params, e.g. `trk_element`, `trk_location`. `trk_copy`
 *   }
 * })
 * middlewares.push(metricsMiddleware);
 */

export default (function (_ref) {
  var appName = _ref.appName,
      trk = _ref.trk,
      amplitudeOnlyTrk = _ref.amplitudeOnlyTrk;
  var isFirstDispatchedAction = true;
  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      return function (action) {
        // before the first action fires on app, update the stores tracking info
        if (typeof window !== 'undefined' && isFirstDispatchedAction) {
          isFirstDispatchedAction = false;
          dispatch(updateTrackingParams({
            trk: trk,
            amplitudeOnlyTrk: amplitudeOnlyTrk,
            appName: appName
          }));
        }

        var prevState = getState();
        var returnValue = next(action);
        var nextState = getState();

        if (typeof window !== 'undefined') {
          metricsBills(nextState, action);
          metricsRequests(nextState, action);
          metricsToastr(nextState, action);
          metricsProviderState(prevState, nextState);
          metricsYodlee(nextState, action);
        }

        return returnValue;
      };
    };
  };
});